module.exports = __webpack_public_path__ + "static/media/thank-you.41f265e2.png";